import type { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import type { ComponentProps } from 'react'

import {
  FINANCIAL_SECTION_URL_VALUE,
  PLANNING_SECTION_URL_SEGMENT,
  TAB_URL,
} from 'partner360/configs'
import { resolveJbpPlanActionParam } from 'partner360/lib/jbpPlanActionFlow'

import { useCockpitSectionNavigation } from '../../../components/cockpitSectionNavigation'
import { useMissingSobCategories } from '../attentionStatusSobActuals'

import { ManagerPbmReminderStep } from './ManagerPbmReminderStep'

type TProps = Omit<ComponentProps<typeof ManagerPbmReminderStep>, 'onOpenPlan' | 'offering'> & {
  offering: string
}

/**
 * `Remind PBM` for a partner's missing SOB actuals on the manager cockpit, for a reader who is not
 * the partner's PBM. The plan beside it opens on the FinSOB section, at the first category still
 * owing its actuals. Rendered inside the partner's scope, so the categories are that partner's.
 */
export const ManagerSobReminderStep = ({ offering, ...props }: TProps) => {
  const { categories } = useMissingSobCategories(offering as ProgramTypes)
  const { openSection } = useCockpitSectionNavigation()

  const openSob = () =>
    openSection({
      [TAB_URL]: FINANCIAL_SECTION_URL_VALUE,
      [PLANNING_SECTION_URL_SEGMENT]: resolveJbpPlanActionParam(categories[0]?.category),
    })

  return <ManagerPbmReminderStep {...props} offering={offering} onOpenPlan={openSob} />
}

ManagerSobReminderStep.displayName = 'ManagerSobReminderStep'
